/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EmrClusterDefinitionCreateRequest } from '../model/emrClusterDefinitionCreateRequest';
import { EmrClusterDefinitionInformation } from '../model/emrClusterDefinitionInformation';
import { EmrClusterDefinitionKeys } from '../model/emrClusterDefinitionKeys';
import { EmrClusterDefinitionUpdateRequest } from '../model/emrClusterDefinitionUpdateRequest';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class EMRClusterDefinitionService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createEmrClusterDefinition
     * Creates a new EMR cluster definition. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param emrClusterDefinitionCreateRequest the information needed to create an EMR cluster definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRClusterDefinitionCreateEmrClusterDefinition(emrClusterDefinitionCreateRequest: EmrClusterDefinitionCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<EmrClusterDefinitionInformation>;
    public eMRClusterDefinitionCreateEmrClusterDefinition(emrClusterDefinitionCreateRequest: EmrClusterDefinitionCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrClusterDefinitionInformation>>;
    public eMRClusterDefinitionCreateEmrClusterDefinition(emrClusterDefinitionCreateRequest: EmrClusterDefinitionCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrClusterDefinitionInformation>>;
    public eMRClusterDefinitionCreateEmrClusterDefinition(emrClusterDefinitionCreateRequest: EmrClusterDefinitionCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (emrClusterDefinitionCreateRequest === null || emrClusterDefinitionCreateRequest === undefined) {
            throw new Error('Required parameter emrClusterDefinitionCreateRequest was null or undefined when calling eMRClusterDefinitionCreateEmrClusterDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EmrClusterDefinitionInformation>(`${this.configuration.basePath}/emrClusterDefinitions`,
            emrClusterDefinitionCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteEmrClusterDefinition
     * Deletes an existing EMR cluster definition by namespace and name. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param emrClusterDefinitionName the EMR cluster definition name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRClusterDefinitionDeleteEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, observe?: 'body', reportProgress?: boolean): Observable<EmrClusterDefinitionInformation>;
    public eMRClusterDefinitionDeleteEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrClusterDefinitionInformation>>;
    public eMRClusterDefinitionDeleteEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrClusterDefinitionInformation>>;
    public eMRClusterDefinitionDeleteEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling eMRClusterDefinitionDeleteEmrClusterDefinition.');
        }
        if (emrClusterDefinitionName === null || emrClusterDefinitionName === undefined) {
            throw new Error('Required parameter emrClusterDefinitionName was null or undefined when calling eMRClusterDefinitionDeleteEmrClusterDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<EmrClusterDefinitionInformation>(`${this.configuration.basePath}/emrClusterDefinitions/namespaces/${encodeURIComponent(String(namespace))}/emrClusterDefinitionNames/${encodeURIComponent(String(emrClusterDefinitionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getEmrClusterDefinition
     * Gets an existing EMR cluster definition by namespace and name. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param emrClusterDefinitionName the EMR cluster definition name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRClusterDefinitionGetEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, observe?: 'body', reportProgress?: boolean): Observable<EmrClusterDefinitionInformation>;
    public eMRClusterDefinitionGetEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrClusterDefinitionInformation>>;
    public eMRClusterDefinitionGetEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrClusterDefinitionInformation>>;
    public eMRClusterDefinitionGetEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling eMRClusterDefinitionGetEmrClusterDefinition.');
        }
        if (emrClusterDefinitionName === null || emrClusterDefinitionName === undefined) {
            throw new Error('Required parameter emrClusterDefinitionName was null or undefined when calling eMRClusterDefinitionGetEmrClusterDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EmrClusterDefinitionInformation>(`${this.configuration.basePath}/emrClusterDefinitions/namespaces/${encodeURIComponent(String(namespace))}/emrClusterDefinitionNames/${encodeURIComponent(String(emrClusterDefinitionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getEmrClusterDefinitions
     * Gets a list of keys for all EMR cluster definitions defined in the system for the specified namespace. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRClusterDefinitionGetEmrClusterDefinitions(namespace: string, observe?: 'body', reportProgress?: boolean): Observable<EmrClusterDefinitionKeys>;
    public eMRClusterDefinitionGetEmrClusterDefinitions(namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrClusterDefinitionKeys>>;
    public eMRClusterDefinitionGetEmrClusterDefinitions(namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrClusterDefinitionKeys>>;
    public eMRClusterDefinitionGetEmrClusterDefinitions(namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling eMRClusterDefinitionGetEmrClusterDefinitions.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EmrClusterDefinitionKeys>(`${this.configuration.basePath}/emrClusterDefinitions/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateEmrClusterDefinition
     * Updates an existing EMR cluster definition by namespace and name. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace
     * @param emrClusterDefinitionName the EMR cluster definition name
     * @param emrClusterDefinitionUpdateRequest the information needed to update the EMR cluster definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public eMRClusterDefinitionUpdateEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, emrClusterDefinitionUpdateRequest: EmrClusterDefinitionUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<EmrClusterDefinitionInformation>;
    public eMRClusterDefinitionUpdateEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, emrClusterDefinitionUpdateRequest: EmrClusterDefinitionUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmrClusterDefinitionInformation>>;
    public eMRClusterDefinitionUpdateEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, emrClusterDefinitionUpdateRequest: EmrClusterDefinitionUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmrClusterDefinitionInformation>>;
    public eMRClusterDefinitionUpdateEmrClusterDefinition(namespace: string, emrClusterDefinitionName: string, emrClusterDefinitionUpdateRequest: EmrClusterDefinitionUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling eMRClusterDefinitionUpdateEmrClusterDefinition.');
        }
        if (emrClusterDefinitionName === null || emrClusterDefinitionName === undefined) {
            throw new Error('Required parameter emrClusterDefinitionName was null or undefined when calling eMRClusterDefinitionUpdateEmrClusterDefinition.');
        }
        if (emrClusterDefinitionUpdateRequest === null || emrClusterDefinitionUpdateRequest === undefined) {
            throw new Error('Required parameter emrClusterDefinitionUpdateRequest was null or undefined when calling eMRClusterDefinitionUpdateEmrClusterDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<EmrClusterDefinitionInformation>(`${this.configuration.basePath}/emrClusterDefinitions/namespaces/${encodeURIComponent(String(namespace))}/emrClusterDefinitionNames/${encodeURIComponent(String(emrClusterDefinitionName))}`,
            emrClusterDefinitionUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
